import React, { useContext } from 'react';

import AGPSettingsContext from './AGPSettingsContext';

function AGPLabels({ t }) {
  const { percentile, setPercentile } = useContext(AGPSettingsContext);

  return (
    <g className="agp labels" transform="translate(2,0)">
      <g className="percentile upper" transform="translate(0, 175)">
        <rect
          className="sensor legend"
          y="-10"
          width="30"
          height="20"
          onClick={() => {
            setPercentile(percentile === 90 ? 80 : 90);
          }}
        />
        <text dx="3" dy="0.35em">{`${100 - (100 - percentile) / 2}%`}</text>
      </g>
      <g className="interquartile upper" transform="translate(0, 200)">
        <rect className="sensor legend" y="-10" width="30" height="20" />
        <text dx="3" dy="0.35em">
          75%
        </text>
      </g>
      <g className="median" transform="translate(0, 225)">
        <rect className="sensor legend" y="-10" width="30" height="20" />
        <text dx="3" dy="0.35em" className="median">
          {t('agp.graph.labels.median')}
        </text>
      </g>
      <g className="interquartile lower" transform="translate(0, 250)">
        <rect className="sensor legend" y="-10" width="30" height="20" />
        <text dx="3" dy="0.35em">
          25%
        </text>
      </g>
      <g className="percentile lower" transform="translate(0, 275)">
        <rect
          className="sensor legend"
          y="-10"
          width="30"
          height="20"
          onClick={() => {
            setPercentile(percentile === 90 ? 80 : 90);
          }}
        />
        <text dx="3" dy="0.35em">{`${(100 - percentile) / 2}%`}</text>
      </g>
    </g>
  );
}

export default AGPLabels;
